import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataUpdateObservableService {
  myMessage: boolean = false;
  private messageSource = new BehaviorSubject<boolean>(false);
  currentMessage = this.messageSource.asObservable();
  notifyUpdated() {
    this.messageSource.next(true);
    setTimeout(() => {
      this.messageSource.next(false);
    }, 100);
  }
}